import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=59c86750&scoped=true&"
import script from "./product-detail.vue?vue&type=script&lang=tsx&"
export * from "./product-detail.vue?vue&type=script&lang=tsx&"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=59c86750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c86750",
  null
  
)

export default component.exports